import React from 'react'

const DurumBadge = ({ text }) => {
  const selectColor = (text) => {
    switch (text) {
      case 'Aktif':
        return '#FFB300'
      case 'Beklemede':
        return '#FFB300'
      case 'Çıkış Yapıldı':
      case 'Dışarıda':
        return '#DC3545'
      case 'Giriş Yapıldı':
      case 'İçeride':
        return '#15AC3D'
      case 'İptal Edildi':
        return '#D62D1A'
      case 'Süresi Doldu':
        return '#787878'

      default:
        return '#787878'
    }
  }

  return (
    <div
      style={{
        color: '#fff',
        padding:'0 .7rem .1rem .7rem',
        borderRadius: '15px',
        backgroundColor: selectColor(text),
      }}
    >
      {text}
    </div>
  )
}

export default DurumBadge
